// extracted by mini-css-extract-plugin
module.exports = {"paginationTokens":"pagination_paginationTokens__vfckl","pagination":"pagination_pagination__8mnhI","dark":"pagination_dark__xzA_H"};